import { Component } from "@angular/core";
import { OmniarkUiModule } from "@corp-ais/omniark-ui";
import { EnrichmentList } from "./components/list/enrichment-list/enrichment-list";

@Component({
  selector: "app-enrichment",
  imports: [OmniarkUiModule, EnrichmentList],
  templateUrl: "./enrichment.html",
  styleUrl: "./enrichment.scss",
})
export class Enrichment {}
